const SettingRoutes = [
    {
        path: '/setting/function-flow',
        component: () => import('@/views/Setting/FunctionFow/FunctionFlowView.vue'),
    },
    {
        path: '/setting/template',
        component: () => import('@/views/Setting/Template/PageTemplateView.vue'),
    },
    {
        path: '/setting/workflow-condition',
        component: () => import('@/views/Setting/WorkflowCondition/WorkflowCondition.vue'),
    },
    {
        path: '/setting/registeruser',
        component: () => import('@/views/Setting/RegisterUser/RegisterUser.vue'),
    },
    {
        path: '/setting/workflow-builder',
        component: () => import('@/views/Setting/WorkflowBuilder/WorkflowBuilder.vue'),
    },
    {
        path: '/setting/general',
        component: () => import('@/views/Setting/GeneralView.vue'),
    },
    {
        path: '/setting/menu',
        component: () => import('@/views/Setting/SuperAdmin/SettingMenu.vue'),
    },
    {
        path: '/setting/configuration',
        component: () => import('@/views/Setting/Configuration/index.vue'),
    },
    {
        path: '/setting/audit-log',
        component: () => import('@/views/AuditLog/AuditLogView.vue'),
    },
    {
        path: '/setting/company',
        component: () => import('@/views/Setting/Configuration/Company.vue'),
    },
    {
        path: '/setting/module',
        component: () => import('@/views/Setting/SuperAdmin/UserRole/Module.vue'),
    },
]

export default SettingRoutes
